module.exports = __webpack_public_path__ + "static/img/about_img.7dd93dde.jpg";